import { createContext, useContext } from 'react';
import type { MarketingBootstrap } from './types';

export const MarketingContext = createContext<MarketingBootstrap | null>(null);

export function useMarketing() {
  const value = useContext(MarketingContext);
  if (!value) throw new Error('MarketingContext отсутствует');
  return value;
}
